import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const startYear = 2025; // As per your request
  // If current year is 2025, display "© 2025". Otherwise, "© 2025-YYYY".
  const yearDisplay = currentYear === startYear ? startYear.toString() : `${startYear}-${currentYear}`;

  return (
    <footer className={styles.footerContainer}>
      <p className={styles.footerText}>
        &copy; {yearDisplay} Statusbond. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
